export const url = "https://pos.thelocaldaily.in/api";
// export const url = "https://erp-api.zsmaterials.in/api";
export const IMAGE_URL =
  "https://pos.thelocaldaily.in/api/image/upload-image";
